import { useTranslation } from "react-i18next";

import { LocaleSwitcher } from "@/components/LocaleSwitcher";

export function SettingsPage() {
  const { t } = useTranslation("common");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">{t("settings.title")}</h1>
        <p className="mt-1 text-sm text-slate-500">{t("settings.subtitle")}</p>
      </div>

      <div className="card max-w-xl">
        <div className="card-header">
          <h2 className="text-base font-semibold">{t("settings.languageTitle")}</h2>
        </div>
        <div className="card-body flex items-center justify-between gap-4 text-sm text-slate-500">
          <p>{t("settings.languageDescription")}</p>
          <LocaleSwitcher id="settings-locale-switcher" />
        </div>
      </div>
    </div>
  );
}
